/** Explicit, loopback-only development preview; never an authorization flag. */
export function isLocalSearchDemo(dev=import.meta.env.DEV,url=window.location.href) {
  const location=new URL(url);
  return dev && location.hostname==='127.0.0.1' && location.port==='5187' && location.searchParams.get('searchDemo')==='all-departments';
}
